<template>
    <el-dialog
            :visible.sync="show"
            :close-on-click-modal="false"
            append-to-body
            width="60%">

        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="time.YmdHis" label="操作时间" min-width="140">
            </el-table-column>

            <el-table-column prop="num" label="表现分变化" min-width="100">
            </el-table-column>

            <el-table-column prop="surplus" label="当前表现分" min-width="100">
            </el-table-column>

            <el-table-column prop="description" label="备注" min-width="160">
            </el-table-column>

            <el-table-column prop="source" label="操作人" min-width="200">
            </el-table-column>

        </el-table>
        <el-pagination
                class="pagination"
                layout="prev, pager, next"
                :total="result_data.count"
                @current-change="handleCurrentChange"
        >
        </el-pagination>
    </el-dialog>
</template>

<script>
    let _this;
    export default {
        props: {
            'isShow': Boolean,
            'data':''
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

                _this.search_data.driver_code = _this.data;

               _this.getList()

            },

        },
        created() {
            _this = this;
        },
        data() {
            return {
                show:false,

                search_data:{
                    page:1,
                    limit:10,
                    driver_code:'',
                    fixed_array:'',
                    real_name:''
                },

                tableData:[],
                result_data:{}
            }
        },
        methods:{
            getList(){
                _this.$post(
                    "/statistics/driverRecordMonitorCouponLists",
                    _this.search_data
                ).then(res => {
                    _this.result_data = res;
                    _this.tableData = res.data;
                })
            },
            handleCurrentChange(val){
                _this.search_data.page = val;

                _this.getList()

            }
        }
    };
</script>

<style scoped>
.pagination{
    text-align: right;
}
</style>
